import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["hosting"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { fetchOk } from '@atlassian/mpac-fetch-wrapper';
import { DateUtils, log } from '@atlassian/mpac-utils';
function transformGetReviewsResponse(response, isAetherEnabled) {
  var _response$_links$next;
  const {
    selfUserReview,
    averageStars,
    count
  } = response;
  const reviews = response._embedded.reviews;
  const moreReviewsEndpoint = (_response$_links$next = response._links.next) === null || _response$_links$next === void 0 ? void 0 : _response$_links$next.href;
  const selfEndpoint = response._links.self.href;
  const transformedReviews = reviews.map(rawReview => transformReview(rawReview));
  let selfUserReviewData;
  // check for own/self review in the list of reviews
  if (isAetherEnabled && selfUserReview) {
    selfUserReviewData = transformedReviews.find(review => review.id === selfUserReview.id);
    if (selfUserReviewData) {
      // remove self review from reviews list
      transformedReviews.splice(transformedReviews.indexOf(selfUserReviewData), 1);
    }
  }
  const reviewsResponse = {
    reviews: transformedReviews,
    hasMoreReviews: !!moreReviewsEndpoint,
    moreReviewsEndpoint,
    selfEndpoint,
    selfUserReview,
    selfUserReviewData,
    appRating: {
      avgStars: averageStars,
      numRatings: count
    }
  };
  return reviewsResponse;
}
function transformReview(reviewData) {
  let isPostReview = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  const {
    _embedded,
    _links,
    totalVotes,
    stars,
    date,
    id,
    helpfulVotes,
    hosting,
    review
  } = reviewData;
  const author = _embedded.author;
  const transformedAuthor = {
    name: author.name,
    id: author.id,
    isReviewAuthor: author.isReviewAuthor || !!isPostReview,
    picture: author._links.picture.href,
    profileUrl: author._links.alternate.href
  };
  const transformedRatings = {
    avgStars: stars,
    numRatings: 1
  };
  const {
    voteUp,
    voteDown,
    self,
    flag,
    response
  } = _links;
  const vendorResponse = _embedded.response;
  const transformedVendorResponse = {
    response: vendorResponse === null || vendorResponse === void 0 ? void 0 : vendorResponse.text,
    responseEndpoint: (vendorResponse === null || vendorResponse === void 0 ? void 0 : vendorResponse._links.self.href) || (response === null || response === void 0 ? void 0 : response.href)
  };
  return {
    id,
    totalVotes,
    helpfulVotes,
    hosting,
    review,
    date: DateUtils.longDate(date),
    ratings: transformedRatings,
    author: transformedAuthor,
    vendor: transformedVendorResponse,
    selfEndpoint: self === null || self === void 0 ? void 0 : self.href,
    voteUpEndpoint: voteUp === null || voteUp === void 0 ? void 0 : voteUp.href,
    voteDownEndpoint: voteDown === null || voteDown === void 0 ? void 0 : voteDown.href,
    flagEndpoint: flag === null || flag === void 0 ? void 0 : flag.href
  };
}
export const getReviewsEndpoint = function getReviewsEndpoint(appKey, queryParams) {
  let limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '5';
  const {
      hosting
    } = queryParams,
    restParams = _objectWithoutProperties(queryParams, _excluded);
  const params = _objectSpread({
    limit,
    hosting: hosting.toLowerCase()
  }, restParams);
  const queryString = new URLSearchParams(params).toString();
  return "/rest/2/addons/".concat(appKey, "/reviews?").concat(queryString);
};
export const getReviewById = async (appKey, reviewId) => {
  const options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    },
    cache: 'no-cache'
  };
  const res = await fetchOk("/rest/2/addons/".concat(appKey, "/reviews/id/").concat(reviewId), options);
  if (!res.ok) {
    log.error("getReviewById failed for /rest/2/addons/".concat(appKey, "/reviews/id/").concat(reviewId, " ;"), res.statusText);
    return;
  }
  const reviewRaw = await res.json();
  return transformReview(reviewRaw);
};
export const getMyReview = async appKey => {
  const options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    },
    cache: 'no-cache'
  };
  const res = await fetchOk("/rest/2/addons/".concat(appKey, "/reviews/mine"), options);
  if (!res.ok) {
    log.error("getMyReview api failed for /rest/2/addons/".concat(appKey, "/reviews/mine ;"), res.statusText);
    return;
  }
  const reviewRaw = await res.json();
  return transformReview(reviewRaw);
};
export const getReviews = async function getReviews(reviewsUrl) {
  let isAetherEnabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  const response = await fetchOk(reviewsUrl, {
    cache: 'no-store'
  });
  const reviewsResponse = await response.json();
  return transformGetReviewsResponse(reviewsResponse, isAetherEnabled);
};
export const deleteReview = _ref => {
  let [deleteReviewUrl] = _ref;
  return fetchOk(deleteReviewUrl, {
    method: 'DELETE',
    cache: 'no-cache'
  });
};
export const voteReview = _ref2 => {
  let [voteReviewUrl, voteState = true] = _ref2;
  const options = {
    method: 'PUT',
    body: JSON.stringify({
      state: voteState
    }),
    headers: {
      'Content-Type': 'application/json'
    }
  };
  return fetchOk(voteReviewUrl, options);
};
export const deleteVendorResponse = _ref3 => {
  let [deleteVendorResponseUrl] = _ref3;
  return fetchOk(deleteVendorResponseUrl, {
    method: 'DELETE'
  });
};
export const flagReview = _ref4 => {
  let [flagReviewUrl, flagState] = _ref4;
  const options = {
    method: 'PUT',
    body: JSON.stringify({
      state: flagState
    }),
    headers: {
      'Content-Type': 'application/json'
    }
  };
  return fetchOk(flagReviewUrl, options);
};
const getPostedReviewDetails = async endpoint => {
  const result = await fetchOk(endpoint, {
    cache: 'no-cache'
  });
  const review = await result.json();
  return transformReview(review, true);
};
export const postReview = async _ref5 => {
  let [url, data] = _ref5;
  const options = {
    method: 'POST',
    body: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json'
    }
  };
  const result = await fetchOk(url, options);
  const postedReviewDetailsEndpoint = result.headers.get('location');
  if (postedReviewDetailsEndpoint) {
    const postedReviewDetails = await getPostedReviewDetails(postedReviewDetailsEndpoint);
    return postedReviewDetails;
  }
};
export const postVendorResponse = _ref6 => {
  let [vendorResponseUrl, vendorResponse] = _ref6;
  const options = {
    method: 'PUT',
    body: JSON.stringify({
      text: vendorResponse
    }),
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  };
  return fetchOk(vendorResponseUrl, options);
};